<dialog-header [dialogRef]="dialogRef" headerKey="FILTER_NAME"></dialog-header>
<div mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{ 'NAME' | translate }}</mat-label>
      <input matInput formControlName="name" maxlength="50">
      <mat-error>{{ errorLabel }}</mat-error>
    </mat-form-field>
    <dialog-buttons></dialog-buttons>
  </form>
</div>
